import { knownApiErrorAgentData } from "src/components/common/errors/knownApiErrorAgentData.ts";
import type { JsonObject } from "src/components/views/ai/assistant/uiContext/jsonTypes.ts";
import type { LoggedError } from "src/errorHandling/errorLogging.ts";

export function errorAgentData(error: LoggedError): JsonObject {
	const logIds = [error.sentryEventId, error.backendLogId].filter((logId): logId is string => logId != null);
	const data: JsonObject = {
		errorMessage: error.message,
		errorName: error.error.name,
		sentryEventId: error.sentryEventId ?? null,
		backendLogId: error.backendLogId ?? null,
		logId: logIds.length === 0 ? null : logIds.join("-"),
		customFunctionExecutionId: error.customFunctionExecutionId ?? null,
	};
	if (error.knownError != null) {
		data.knownError = knownApiErrorAgentData(error.knownError);
	}
	return data;
}
